export default __webpack_public_path__ + "static/media/1.f17de971.jpg";